import axios from "axios";
import { Message } from "element-ui";
import { getToken } from "./getCookies";

let baseURL = process.env.VUE_APP_BASE_URL
const instance = axios.create({
    timeout: 30000,
    baseURL: process.env.NODE_ENV =='development'?'':baseURL,
});

//请求拦截器
instance.interceptors.request.use(config => {
    const token = getToken();
    if ( token ) {
        config.headers['X-Access-Token'] = token;
    }
    // config.headers['Access-Control-Allow-Origin'] = '*'
    return config;
});

//响应拦截器
instance.interceptors.response.use((response) => {
    try {
        if (!response.data.success) {
            Message({
                message: response.data.message,
                type: "error",
            })
        }
    } catch {
        Message({
            message: "网络请求失败，请重试",
            type: "error",
        })
    }

    return response;
}, (error) => {
    let tip = error
    if (error.code === 'ECONNABORTED') {
        tip = '请求超时，请重试'
    }
    Message({
        message: tip,
        type: "error"
    })
});

export function get(url, params = {}, config = {}) {
    return instance.get(url, { params, ...config });
}

export function post(url, params = {}, config = {}) {
    return instance.post(url, params, config);
}

export function put(url, params = {}, config = {}) {
    return instance.put(url, params, config);
}
